<div class="encoding-zone-container">
  <div class="mark-zone zone margin-bottom-medium">
    <!-- Show simplified color palette dropdown for high charts -->
    <mode-color-palette-assignment
      *ngIf="!useMuzeRenderer"
      [selectedColorPalette]="selectedColorPalette"
      [allColorPalettes]="allColorPalettes"
      (paletteAssigned)="onPaletteAssigned($event)"
    ></mode-color-palette-assignment>

    <div class="header" *ngIf="useMuzeRenderer">Color</div>
    <div class="pane">
      <mode-color-channel-component
        class="channel-row"
        [channelSummary]="colorMarkField"
        [encoding]="encoding"
        [model]="model"
        [view]="view"
        [renderModel]="renderModel$ | async"
        [chartService]="chartService"
        [chartType]="chartType"
        [queryToken]="queryToken$ | async"
        [queryRunToken]="queryRunToken$ | async"
        [vizToken]="vizToken$ | async"
        [fieldFormatMap]="fieldFormatMap$ | async"
        [fieldColorMap]="fieldColorMap$ | async"
        [format]="format$ | async"
        [isAutoOrManualRender]="isAutoOrManualRender$ | async"
        [useMeasureNamesPill]="true"
        [zone]="colorChannelZone"
        [allowContinuous]="false"
        [allowDiscrete]="true"
        [allowAggregates]="false"
        [disabled]="!isValidForColor"
        [hideAdvancedColorSelection]="!useMuzeRenderer"
      ></mode-color-channel-component>
      <mode-typeahead-attrs-list
        *ngIf="colorMarkField?.type === 'field'"
        class="empty-drop-zone--typeahead"
        [class.drag-highlight]="isDragging"
        data-test="marks-dropzone"
        dndDropzone
        placeholderText="Replace field..."
        [view]="view"
        [chartType]="chartType"
        (attrSelected)="onTypeAheadSelection($event, 'color')"
        (dndDrop)="onDropOnTypeAhead($event, 'color')"
      ></mode-typeahead-attrs-list>
    </div>
  </div>
  <div class="mark-zone zone margin-bottom-medium">
    <div class="header">Angle</div>
    <div class="pane">
      <mode-channel-component
        class="channel-row"
        [channelSummary]="angleMarkField"
        [encoding]="encoding"
        [model]="model"
        [view]="view"
        [chartService]="chartService"
        [chartType]="chartType"
        [queryToken]="queryToken$ | async"
        [vizToken]="vizToken$ | async"
        [fieldFormatMap]="fieldFormatMap$ | async"
        [format]="format$ | async"
        [allowContinuous]="true"
        [allowScalars]="false"
        [allowDiscrete]="false"
        [requiresContinuous]="true"
      ></mode-channel-component>
      <mode-typeahead-attrs-list
        *ngIf="angleMarkField?.type === 'field'"
        class="empty-drop-zone--typeahead"
        [class.drag-highlight]="isDragging"
        data-test="marks-dropzone"
        dndDropzone
        placeholderText="Replace field..."
        [view]="view"
        [chartType]="chartType"
        (attrSelected)="onTypeAheadSelection($event, 'angle')"
        (dndDrop)="onDropOnTypeAhead($event, 'angle')"
      ></mode-typeahead-attrs-list>
    </div>
  </div>
</div>
